import { render } from "./ReceiversFirstUseBlankslate.vue?vue&type=template&id=475e2730"
import script from "./ReceiversFirstUseBlankslate.vue?vue&type=script&lang=js"
export * from "./ReceiversFirstUseBlankslate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__